import React, { Component } from "react";

import { CCard, CCardHeader, CCardBody, CLabel, CButton } from "@coreui/react";
import { connect } from "react-redux";
import Select from "react-select";
import {
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormGroup,
  Modal,
  ModalHeader,
  Label,
  ModalBody
} from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import ContentComponent from "../../../../components/Content/content";
import Loading from "../../../../components/Loading";
import CreateFilterOffline from "../../../../components/OfflineRegister/CreateFilterOffline";
import StudentPresenceTable from "../../../../components/OfflineRegister/StudentPresenceTable";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

class ViewOfflineRegister extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // continue: true,
      loading: false,
      type: 0,
      typeName: "Todos",
      typeIcon: "",
      typeColor: "",
      types: [],
      showModal: false,
      contents: [],
      // disciplineList: null,
      disciplineSelected: null,
      date: null,
      // room_id: null,
      // user_id: null,
      // teacher_id: null,
      student_list: null,
      infoSelected: null,
      modalAddRegister: false,
      // data: {
      //   group_name: "Educandus",
      //   region_name: "ABC Regional",
      //   school_name: "Escola 1 ABC",
      //   room_name: "Ensino Infantil",
      //   teacher_name: "Professor 01",
      //   date: "2022-11-10 12:25:19",
      //   discipline_name: "Matemática",
      //   contents: ["Lixo", "Conteúdo"],
      //   users: [{ id: 1, user_name: "Marcelo", accessed: true }]
      // },
      data: null
    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    this.setState({ loading: true });
    axios
      .get(`${URL.api}offline/register/singleView/${id}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        let newUsers = [];
        resp.data.data.users.forEach(item => {
          let obj = {
            id: item.id,
            nome: item.student_name,
            status: item.accessed === true ? "Presente" : "Ausente"
          };
          newUsers.push(obj);
        });
        let newData = resp.data.data;
        newData.users = newUsers;
        this.setState({ data: newData });
      });
  }

  changeDisciplineSelected = disciplineSelected => {
    this.setState({ disciplineSelected });
  };

  getStudentList = studentList => {
    this.setState({ student_list: studentList });
  };

  removeContent = contentName => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const contentList = [...this.state.contents];
    const position = contentList.indexOf(contentName);
    contentList.splice(position, 1);
    this.setState({ contents: contentList });
  };

  addContent = (contentName, contentId) => {
    // eslint-disable-next-line react/no-access-state-in-setstate
    const contentList = [...this.state.contents];
    let obj = {
      contentName,
      contentId
    };
    contentList.push(obj);
    this.setState({ contents: contentList });
  };

  hideModal = hide => {
    this.setState({ showModal: !hide });
  };

  getDate = date => {
    let myDate = `${date}`;
    myDate = myDate.replaceAll("-", ".");
    let newDate = new Date(Math.floor(new Date(myDate).getTime()));
    this.setState({ date: newDate });
  };

  getInfoSelectors = (groupId, regionId, schoolId, roomId, teacherId) => {
    let obj = {
      groupId,
      regionId,
      schoolId,
      roomId,
      teacherId
    };
    this.setState({ infoSelected: obj });
  };

  addNewRegister = addAnotherRoom => {
    let studentList = [];
    this.state.student_list.forEach(item => {
      let obj = {
        student_id: item.id,
        accessed: item.status === "Presente"
      };
      studentList.push(obj);
    });

    let contentList = [];
    this.state.contents.forEach(item => {
      contentList.push(item.contentId);
    });

    let obj = {
      user_id: this.props.user.user.id,
      room_id: this.state.infoSelected.roomId,
      discipline_id: this.state.disciplineSelected.value,
      date: this.state.date,
      users: studentList,
      content: contentList,
      teacher_id:
        this.state.infoSelected.teacherId !== 0
          ? this.state.infoSelected.teacherId
          : null
    };
    axios
      .post(`${URL.api}offline/register/insert`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(() => {
        if (!addAnotherRoom) {
          let url = "/offline/register/list";
          this.props.history.push(url);
        } else {
          this.disableFields;
        }
        resp => {},
          () => {
            this.error("Não foi possível adicionar o Registro Offline");
          };
      });
  };

  disableFields = () => {};

  render() {
    const query = new URLSearchParams(this.props.location.search);
    const serie = query.get("serie") || null;
    const discipline = query.get("discipline") || null;

    return (
      <div className="d-flex flex-column align-items-left">
        <Breadcrumb current={this.props.currentRoute} />
        {this.state.data && (
          <CCard>
            <CCardHeader className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <h4 className="card-title mb-1">Visualizar Registro Offline</h4>
                <div className="small text-muted">
                  Visualize os dados do Registro Offline
                </div>
              </div>
            </CCardHeader>
            <CCardBody>
              <CreateFilterOffline
                user={this.props.user}
                getDate={this.getDate}
                getInfoSelectors={this.getInfoSelectors}
                viewOfflineRegister
                infoView={this.state.data}
              />
              <div className="myRow">
                <div className="flex-1 mb-2">
                  <div className="w-100 text-ellipsis">
                    <Label className="d-block w-100 text-ellipsis">
                      Disciplina
                    </Label>
                  </div>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa fa-text-width"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Select
                      placeholder="Selecione a Disciplina"
                      onChange={e => this.changeDisciplineSelected(e)}
                      defaultValue={{
                        label: this.state.data.discipline_name,
                        value: 0
                      }}
                      type="text"
                      isDisabled
                      className="flex-1"
                    />
                  </InputGroup>
                </div>
                <FormGroup className="mb3">
                  <CLabel>Conteúdos</CLabel>
                  <div style={{ display: "flex" }}>
                    {this.state.data.content.length ? (
                      this.state.data.content.map(item => (
                        <CCard className="p-2 mr-2">
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <span>{item.lo_name}</span>
                            <i
                              className="fa fa-remove"
                              onClick={() => this.removeContent(item.lo_name)}
                              style={{ cursor: "pointer", marginLeft: "5px" }}
                            ></i>
                          </div>
                        </CCard>
                      ))
                    ) : (
                      <>
                        <h7 className="text-muted mb-4">
                          Nenhum conteúdo selecionado
                        </h7>
                      </>
                    )}
                  </div>
                </FormGroup>
                <Modal
                  isOpen={this.state.showModal}
                  toggle={null}
                  className={null}
                  onOpened={() => this.componentDidMount()}
                  size="lg"
                >
                  <ModalHeader className="d-flex justify-content-end">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => {
                        this.setState({ showModal: false });
                      }}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </ModalHeader>
                  {this.state.loading ? (
                    <div className="p-4">
                      <Loading />
                    </div>
                  ) : (
                    <ContentComponent
                      type={this.state.type}
                      typeName={this.state.typeName}
                      typeIcon={this.state.typeIcon}
                      typeColor={this.state.typeColor}
                      types={this.state.types}
                      currentRoute={this.props.currentRoute}
                      serie={serie}
                      discipline={discipline}
                      isOfflineRegister
                      addContent={this.addContent}
                      hideModal={this.hideModal}
                      disciplineSelected={this.state.disciplineSelected}
                    />
                  )}
                </Modal>
                <Modal
                  isOpen={this.state.modalAddRegister}
                  toggle={null}
                  className={null}
                  onOpened={() => this.componentDidMount()}
                  size="lg"
                >
                  <ModalHeader className="d-flex justify-content-end">
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={() => {
                        this.setState({ modalAddRegister: false });
                      }}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </ModalHeader>
                  <ModalBody>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        flex: 1
                      }}
                    >
                      <h4 className="card-title mb-1">
                        Quer colocar esse mesmo conteúdo para outra turma?
                      </h4>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        flex: 1
                      }}
                      className="mt-2"
                    >
                      <CButton
                        color="primary"
                        className="ml-2"
                        onClick={() => {
                          this.addNewRegister(true);
                        }}
                      >
                        Sim
                      </CButton>
                      <CButton
                        color="primary"
                        className="ml-2"
                        onClick={() => {
                          this.addNewRegister(false);
                        }}
                      >
                        Não
                      </CButton>
                    </div>
                  </ModalBody>
                </Modal>
                <CLabel className="mt-2">Lista de Presença</CLabel>
                <StudentPresenceTable
                  getStudentList={this.getStudentList}
                  roomId={
                    this.state.infoSelected ? this.state.infoSelected : null
                  }
                  viewOfflineRegister
                  infoView={this.state.data}
                />
              </div>
            </CCardBody>
          </CCard>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewOfflineRegister);
